var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Snackbar from "@mui/material/Snackbar";
import Slide from "@mui/material/Slide";
import Icon from "../Icon";
import { SnackbarStyled, IconButtonStyled } from "./styles";
function SlideTransition(props) {
    return _jsx(Slide, __assign({}, props, { direction: "up" }));
}
export var Toast = function (_a) {
    var open = _a.open, message = _a.message, onDimiss = _a.onDimiss, _b = _a.color, color = _b === void 0 ? "blood" : _b, rest = __rest(_a, ["open", "message", "onDimiss", "color"]);
    return (_jsx(SnackbarStyled, __assign({ as: Snackbar, open: open, message: message, onClose: onDimiss, anchorOrigin: {
            horizontal: "center",
            vertical: "bottom",
        }, color: color, action: onDimiss && (_jsx(IconButtonStyled, __assign({ onClick: function () { return onDimiss(); } }, { children: _jsx(Icon, { name: "filled-close", color: "white" }) }))), TransitionComponent: SlideTransition }, rest)));
};
